































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class BuilderAddButton extends Vue {
  @Prop({ default: false, type: Boolean }) readonly dark!: boolean

  @Prop({ type: String }) readonly label!: string

  @Prop({ default: 'bg-plus', type: String }) readonly icon!: string
}
